import React, { useState } from "react";
import { Link } from "react-router-dom";
import { TextTruncate, dateToFromNowDaily } from "utility/CommonService";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import { EditEntityModal } from "../../components/shared/Modals/EditEntityModal"
import { ENTITY_TYPES, DEFAULT_DATETIME_OPTION } from "utility/constants/constants";
import { updateProject } from "redux/actions/ProjectActions";
import { EntityMenu } from "components/shared/EntityMenu/EntityMenu";

export const ProjectRow = (props) => {
  const { user } = useSelector((state) => state.authReducer);
  const {
    project,
    deleteProject,
    index,
    accessLevel,
    onShare
  } = props;
  const [showEditModal, setShowEditModal] = useState(false);

  const getAuthor = () => {
    return project.users ? project.users.first_name + " " + project.users.last_name : "Unknown";
  };

  const getProjectImage = () => {
    const images = [
      require("assets/custom-styles/images/thumbnails/78_dzz.png"),
      require("assets/custom-styles/images/thumbnails/78_dzz2.jpg"),
      require("assets/custom-styles/images/thumbnails/78_dzz3.jpg"),
      require("assets/custom-styles/images/thumbnails/78_dzz4.jpg"),
      require("assets/custom-styles/images/thumbnails/78_dzz5.jpg"),
    ];
    return images[Math.abs(project.id.toString().hashCode() % 5)];
  };

  return (
    <>
      <div className="col-sm-12"
           key={index}
      >
        <div className="sper__Row">
          <div className="sper__left">
            <div className="sper__img">
              <img src={getProjectImage()} alt="projectimg" />
            </div>
          </div>
          <div className="sper__right">
            <div className="row">
              <div className="col-sm-7">
                <div className="inn__L1">
                  <h4>
                    <Link to={`projects/${project.id}`}>{project.name}</Link>
                  </h4>
                  <p className="word-break">
                    {TextTruncate({
                      text: project.description,
                      limit: 75,
                    })}
                  </p>
                  <div className="inn__bottom">
                    <Link to="/projects">
                    <span className="inn__avtar">
                      <img
                        src={require("assets/custom-styles/images/thumbnails/empty_photo.png")}
                        alt="projectimg"
                        className="mr-1"
                      />
                    </span>
                      {getAuthor()}
                    </Link>
                    <Link to="/projects">
                      <img
                        src={require("assets/custom-styles/images/thumbnails/cal_icn.jpg")}
                        alt="projectimg"
                        className="mr-1"
                      />
                      {project.created_at
                        ? moment(project.created_at).format(user.date_format ? user.date_format: DEFAULT_DATETIME_OPTION)
                        : null}
                    </Link>
                    <Link to="/projects">
                      <img
                        src={require("assets/custom-styles/images/thumbnails/files_icn.jpg")}
                        alt="projectimg"
                        className="mr-1"
                      />
                      {
                        project.notebooks ?
                          project.notebooks.filter((e) => e.status === "active")
                            .length : null
                      }
                    </Link>
                    <Link
                      className="cursor-pointer"
                      to={`/projects/${project.id}/edit`}
                    >
                      <img
                        src={require("assets/custom-styles/images/thumbnails/edit_icn.jpg")}
                        alt="projectimg"
                        className="cursor-pointer mr-1"
                      />
                      {dateToFromNowDaily(project.updated_at)}
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-sm-5">
                <div className="inn__R1">
                  <div className="show_tool">
                    {
                      accessLevel && (
                        <EntityMenu
                          onEdit={() => setShowEditModal(true)}
                          onShare={() => onShare && onShare(project)}
                          onDelete={() => deleteProject(project.id)}
                        />
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <EditEntityModal entity={project} entityType={ENTITY_TYPES.PROJECT} updateEntity={updateProject} showModal={showEditModal} setShowModal={setShowEditModal}/>
    </>
  );
};
